import { gql } from '@apollo/client'
import { DRAFT_PRODUCT_FRAGMENT } from '../fragments/DraftProductFragment'

export const SABRE_RESOLVE_DRAFT_PRODUCT = gql`
  mutation ResolveDraftProduct($input: ResolveDraftProductInput!) {
    resolveDraftProduct(input: $input) {
      draftProduct {
        ...DraftProduct
      }
    }
  }
  ${DRAFT_PRODUCT_FRAGMENT}
`
